// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/global-management/cost-explorer/:id\",\"regex\":\"^/global-management/cost-explorer/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/global-management/cost-explorer/pack/:id\",\"regex\":\"^/global-management/cost-explorer/pack/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/action-requests/:tab\",\"regex\":\"^/action-requests/([^/]+)$\",\"paramNames\":[\"tab\"],\"hasOptionalPrefix\":false},{\"path\":\"/db/:id\",\"regex\":\"^/db/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/explorer/:resourceId\",\"regex\":\"^/explorer/([^/]+)$\",\"paramNames\":[\"resourceId\"],\"hasOptionalPrefix\":false},{\"path\":\"/jobs/:page\",\"regex\":\"^/jobs/([^/]+)$\",\"paramNames\":[\"page\"],\"hasOptionalPrefix\":false},{\"path\":\"/log-space/explore/:id\",\"regex\":\"^/log-space/explore/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/saas-inventory/entra-id/:resourceId\",\"regex\":\"^/saas-inventory/entra-id/([^/]+)$\",\"paramNames\":[\"resourceId\"],\"hasOptionalPrefix\":false},{\"path\":\"/saas-inventory/google-workspace/:resourceId\",\"regex\":\"^/saas-inventory/google-workspace/([^/]+)$\",\"paramNames\":[\"resourceId\"],\"hasOptionalPrefix\":false},{\"path\":\"/saas-inventory/microsoft-365/:connectorId\",\"regex\":\"^/saas-inventory/microsoft-365/([^/]+)$\",\"paramNames\":[\"connectorId\"],\"hasOptionalPrefix\":false},{\"path\":\"/threat-center/threat-findings/:tab\",\"regex\":\"^/threat-center/threat-findings/([^/]+)$\",\"paramNames\":[\"tab\"],\"hasOptionalPrefix\":false},{\"path\":\"/streamlake/:slug*?\",\"regex\":\"^/streamlake(?:/(.*))?$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/:not-found*\",\"regex\":\"^/(.+)$\",\"paramNames\":[\"not-found\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/global-management\"},{\"path\":\"/global-management/action-approvals\"},{\"path\":\"/global-management/ai-agents\"},{\"path\":\"/global-management/api-credentials\"},{\"path\":\"/global-management/audit-logs\"},{\"path\":\"/global-management/cost-explorer\"},{\"path\":\"/global-management/cost-explorer/overview\"},{\"path\":\"/global-management/integrations\"},{\"path\":\"/global-management/notifications\"},{\"path\":\"/global-management/roles\"},{\"path\":\"/global-management/saml\"},{\"path\":\"/global-management/saml-sso-assignments\"},{\"path\":\"/global-management/scanning-accounts/aws-accounts\"},{\"path\":\"/global-management/scanning-accounts/azure-subscriptions\"},{\"path\":\"/global-management/scanning-accounts/gcp-projects\"},{\"path\":\"/global-management/users\"},{\"path\":\"/onboarding\"},{\"path\":\"/onboarding/discovering\"},{\"path\":\"/onboarding/in-progress\"},{\"path\":\"/login\"},{\"path\":\"/login/forgot-password\"},{\"path\":\"/logout\"},{\"path\":\"/register\"},{\"path\":\"/\"},{\"path\":\"/action-requests\"},{\"path\":\"/compliance\"},{\"path\":\"/dashboard\"},{\"path\":\"/data-knowledge-graph\"},{\"path\":\"/inventory\"},{\"path\":\"/log-space/collect\"},{\"path\":\"/log-space/explore\"},{\"path\":\"/notifications\"},{\"path\":\"/saas-inventory\"},{\"path\":\"/search\"},{\"path\":\"/settings/backup-configuration\"},{\"path\":\"/settings/backup-policies\"},{\"path\":\"/settings/classification-policies\"},{\"path\":\"/settings/controls\"},{\"path\":\"/settings/object-filters\"},{\"path\":\"/settings/restore-accounts/aws-accounts\"},{\"path\":\"/settings/restore-accounts/azure-subscriptions\"},{\"path\":\"/settings/restore-accounts/gcp-projects\"},{\"path\":\"/settings/restore-accounts/mongo-atlas-projects\"},{\"path\":\"/settings/restore-accounts/saas-workspaces\"},{\"path\":\"/settings/restore-templates\"},{\"path\":\"/settings/source-accounts/aws-accounts\"},{\"path\":\"/settings/source-accounts/azure-subscriptions\"},{\"path\":\"/settings/source-accounts/azure-tenants\"},{\"path\":\"/settings/source-accounts/discovery-configuration\"},{\"path\":\"/settings/source-accounts/eks-clusters\"},{\"path\":\"/settings/source-accounts/gcp-projects\"},{\"path\":\"/settings/source-accounts/mongo-atlas-projects\"},{\"path\":\"/settings/source-accounts/saas-workspaces\"},{\"path\":\"/settings/staging-buckets\"},{\"path\":\"/settings/vault-accounts\"},{\"path\":\"/settings/vault-accounts/aws-accounts\"},{\"path\":\"/settings/vault-accounts/azure-subscriptions\"},{\"path\":\"/settings/vault-accounts/gcp-projects\"},{\"path\":\"/settings/vaults\"},{\"path\":\"/settings/zero-etl-policies\"},{\"path\":\"/storage-gateway\"},{\"path\":\"/storybook\"},{\"path\":\"/threat-center\"},{\"path\":\"/threat-center/remediation-orchestration\"},{\"path\":\"/threat-center/threat-detection-plan\"},{\"path\":\"/threat-center/threat-exclusion\"},{\"path\":\"/threat-center/threat-findings\"},{\"path\":\"/threat-center/threat-hunting\"},{\"path\":\"/organization\"},{\"path\":\"/organization/cost-explorer\"},{\"path\":\"/organization/settings/saml\"},{\"path\":\"/organization/settings/users\"},{\"path\":\"/forbidden\"}],\"isrRoutes\":[\"/action-requests/:tab\",\"/jobs/:page\",\"/threat-center/threat-findings/:tab\"]}";globalThis["_sentryNextJsVersion"] = "16.4.2";globalThis["_sentryRewritesTunnelPath"] = "/error-handling";import {
  init,
  replayIntegration,
  captureRouterTransitionStart,
} from '@sentry/nextjs';

declare global {
  interface Window {
    __RUNTIME_CONFIG__: {
      sentryDSN: string;
      environment: string;
    };
  }
}

const ignoreList = [/\/(envelope|docs|ingest|auth|_next)/, /launchdarkly/];
const env = (window?.__RUNTIME_CONFIG__?.environment || '').toLowerCase();

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

const hasExpiredTokenBody = (body: unknown) =>
  isRecord(body) &&
  typeof body.error === 'string' &&
  body.error.includes('token is expired');

const isIgnoredApiException = (error: unknown) => {
  if (!isRecord(error)) {
    return false;
  }

  return (
    error.code === 404 ||
    (error.code === 401 && hasExpiredTokenBody(error.body))
  );
};

const isAbortError = (error: unknown) =>
  error instanceof DOMException && error.name === 'AbortError';

const wasCapturedByBrowserGlobalHandler = (event: unknown) => {
  if (!isRecord(event) || !isRecord(event.exception)) {
    return false;
  }

  const values = event.exception.values;
  if (!Array.isArray(values)) {
    return false;
  }

  return values.some((value) => {
    if (!isRecord(value) || !isRecord(value.mechanism)) {
      return false;
    }

    return (
      value.mechanism.type === 'auto.browser.global_handlers.onerror' &&
      value.mechanism.handled === false
    );
  });
};

const isUnhandledBrowserFailedFetch = (error: unknown, event: unknown) =>
  error instanceof TypeError &&
  typeof error.message === 'string' &&
  error.message.startsWith('Failed to fetch') &&
  wasCapturedByBrowserGlobalHandler(event);

// Demo runs on mock data, so replays can capture everything for debugging.
// Every other environment handles real customer data and must be masked.
const isDemo = env === 'demo';
init({
  enabled:
    ['prod', 'testing', 'demo'].includes(env) &&
    window?.location?.host !== 'eon-monitoring.console.eon.io',

  dsn: window?.__RUNTIME_CONFIG__?.sentryDSN,
  environment: env,

  // Demo runs on mock data, so trace everything; sample down elsewhere to
  // keep prod/testing trace volume and quota usage reasonable.
  tracesSampleRate: isDemo ? 1 : 0.2,

  replaysOnErrorSampleRate: 1.0,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.0,

  // Every dataCollection category defaults to on, so PII collection must be switched off per category.
  dataCollection: {
    userInfo: false,
    cookies: false,
    httpHeaders: false,
    httpBodies: [],
  },

  // You can remove this option if you're not planning to use the Sentry Session Replay feature:
  integrations: [
    replayIntegration({
      blockAllMedia: false,
      maskAllInputs: !isDemo,
      maskAllText: !isDemo,
    }),
  ],

  ignoreSpans: ignoreList,

  beforeSend(errorEvent, hint) {
    const originalException = hint.originalException;
    if (
      isIgnoredApiException(originalException) ||
      isAbortError(originalException) ||
      isUnhandledBrowserFailedFetch(originalException, errorEvent)
    ) {
      return null;
    }

    errorEvent.extra = errorEvent.extra || {};
    errorEvent.extra.fullUrl = window.location.href;

    return errorEvent;
  },
});

export const onRouterTransitionStart = captureRouterTransitionStart;

window?.addEventListener('unhandledrejection', function (e) {
  if (
    /ChunkLoadError|Loading chunk [\\s\\S]+ failed/i.test(e?.reason?.message) &&
    performance.now() > 3000
  ) {
    location.reload();
  }
});
